import Logout from './components/logout.vue';

export const routes = [
  { path: '/signout', name: 'signout', component: Logout, display: '', style: '' }
];
